import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/soul";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link is on its way.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="forgot-page" className="min-h-[calc(100vh-73px)] grid place-items-center px-6 py-16">
      <div className="w-full max-w-md glass rounded-2xl p-8 sm:p-10 gold-glow fade-up">
        <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-3">Recover access</p>
        <h1 className="serif text-4xl text-[#F5F1E7] font-light">Forgot password</h1>

        {sent ? (
          <div data-testid="forgot-sent" className="mt-6">
            <p className="text-[#A8A29E] leading-relaxed">
              If an account exists for <span className="text-[#F5F1E7]">{email}</span>, a reset
              link has been sent. Check your inbox and follow the link to choose a new password.
            </p>
            <Link
              to="/login"
              className="mt-8 inline-block rounded-full border border-[#D4AF37]/50 text-[#D4AF37] px-6 py-2.5 hover:bg-[#D4AF37]/10 transition-colors duration-300"
            >
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6">
            <p className="text-[#A8A29E] mb-6">Enter your email and we'll send you a link to reset your password.</p>
            <label className="block">
              <span className="text-xs uppercase tracking-[0.2em] text-[#A8A29E] mb-2 block">Email</span>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3 text-[#F5F1E7] outline-none focus:border-[#D4AF37]/60 transition-colors duration-300 placeholder:text-[#A8A29E]/50"
              />
            </label>
            {error && <p data-testid="forgot-error" className="mt-4 text-sm text-[#C1272D]">{error}</p>}
            <button
              data-testid="forgot-submit-btn"
              type="submit"
              disabled={loading}
              className="mt-7 w-full rounded-full bg-[#D4AF37] text-[#110D14] px-7 py-3.5 font-medium hover:bg-[#e6c860] transition-colors duration-300 disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send reset link"}
            </button>
            <p className="mt-6 text-center text-sm text-[#A8A29E]">
              Remembered it?{" "}
              <Link to="/login" className="text-[#D4AF37] hover:underline">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </main>
  );
}
